import React, { useState, useEffect } from "react";
import "./Slider.css";
import { collection, query, limit, orderBy, getDocs, where } from "firebase/firestore";
import { db } from "../../useFirebase"; // Adjust path as necessary
import { Link } from "react-router-dom"; // Use Link for internal navigation

const Slider = () => {
  const [people, setPeople] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const nowStr = new Date().toISOString();
        const q = query(
          collection(db, "blogs_new"),
          where("createdAt", "<=", nowStr),
          orderBy("createdAt", "desc"),
          limit(10)
        );
        const snapshot = await getDocs(q);
        const fetched = snapshot.docs.map((doc) => {
          const d = doc.data();
          return {
            id: doc.id,
            image: d.cover,
            name: d.author, // or d.name_
            title: d.title,
            quote: d.description, // Using company as the 'quote' or subtitle equivalent
            link: d.type === "internship" ? `/blog/${doc.id}` : `/blog/${doc.id}`,
            // Check if it's legacy link if needed, but assuming all new flow now
            originalData: d,
          };
        });

        if (fetched.length > 0) {
          setPeople(fetched);
        }
      } catch (error) {
        console.error("Error fetching slider blogs:", error);
      }
    };
    fetchFeatured();
  }, []);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  if (people.length === 0) {
    return (
      <section className='sectionblogs'>
        <div className='title'>Loading Featured...</div>
      </section>
    );
  }

  return (
    <section className='sectionblogs'>
      <div className='title'></div>
      <div className='section-center'>
        {people.map((item, indexPeople) => {
          const { id, image, name, title, quote, originalData } = item;
          let position = "nextSlide";
          if (indexPeople === index) {
            position = "activeSlide";
          }
          if (indexPeople === index - 1 || (index === 0 && indexPeople === people.length - 1)) {
            position = "lastSlide";
          }

          // Determine if legacy external link or internal
          const isLegacy = originalData.medium && (originalData.isLegacy || !originalData.contentHtml);

          return (
            <article className={position} key={id}>
              <img src={image} alt={name} className='person-img' />
              <h4>{name}</h4>
              <p className='title2'>{title}</p>
              <p className='text2'>{quote?.length > 200 ? `${quote.slice(0, 200)}...` : quote}</p>
              {isLegacy ?
                <a href={originalData.medium} target='_blank' rel='noreferrer'>
                  <button className='readMore'>Read More</button>
                </a>
              : <Link to={`/blog/${id}`}>
                  <button className='readMore'>Read More</button>
                </Link>
              }
            </article>
          );
        })}
        <button className='prev' onClick={() => setIndex(index - 1)}>
          <i className='fas fa-arrow-left' />
        </button>
        <button className='next' onClick={() => setIndex(index + 1)}>
          <i className='fas fa-arrow-right' />
        </button>
      </div>
    </section>
  );
};

export default Slider;
